module.exports = __webpack_public_path__ + "static/wrapel1-24c2e25f9d38760f93ddee289f56476e.png";